import { details } from "./details";

export const order = {
    namespaced: true,
    modules: {
        details
    }
};



// WEBPACK FOOTER //
// ./src/store/orders/order.js